import { isUndefined } from './isDefined';

export default function capitaliseFirstLetter(string) {
  if (isUndefined(string)) {
    return '';
  }

  return string.charAt(0).toUpperCase(0) + string.slice(1);
}
